(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('InvoiceEnvironmental', InvoiceEnvironmental);

    InvoiceEnvironmental.$inject = ['$resource', 'DateUtils'];

    function InvoiceEnvironmental ($resource, DateUtils) {
        var resourceUrl =  'api/invoice-environmentals/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            },
            'adjust': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
